import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import LxInput from '@lingxi-common-component/sirius-ui/Input';
import SearchIcon from '../../Icons/svgs/SearchSvg';
import SearchList from '../searchList';
import ContactTree from '../tree';
import styles from './index.module.scss';
import { useAppSelector } from '@web-common/state/createStore';
import useContactItemEffect from '@web-common/components/UI/SiriusContact/useContactItemEffect';
import debounce from 'lodash/debounce';
import { api, apis } from 'api';
import { getIn18Text } from 'api';
const productApi = api.requireLogicalApi(apis.productAuthApiImpl);
const nimApi = api.requireLogicalApi(apis.imApiImpl);
const SelectList = props => {
    const { searchAutoFocus = true, showAddOrgBtn, showAddTeamBtn, showAddPersonalBtn, showMailListEye, showNoDataPlaceholder, showSeparator, defaultExpandedKeys, order, defaultSelectList = [], defaultSearchVal, disableCheckList, onSelect, isIM, treeProps, multiple = true, showCheckbox = true, type = ['personal', 'enterprise', 'team', 'recent'], searchType = 'all', searchListProps, onInputChange, onExpand, excludeSelf, useContactId, useEdm, isCustomerFirst = false, useMultiAccount, accountRootKey, noRelateEnterprise, containerHeight, useOrgUnit, showOrgMemberNum = false, flattenPersonalEmails = false, deduplicationByEmail = true, showSearch = true, excludeOrgTypes, } = props;
    const [searchValue, setSearchValue] = useState(defaultSearchVal || '');
    const [selectList, setSelectList] = useState([]);
    const inputRef = useRef(null);
    const contactListRef = useRef(null);
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const showAndUseEdm = useEdm && !!productApi.getABSwitchSync('edm_mail');
    const handleSelect = (itemList, data) => {
        console.info('handleSelect', itemList, data);
        setSelectList(itemList);
        if (!onSelect) {
            return;
        }
        if (multiple) {
            onSelect(itemList, data);
        }
        else {
            onSelect(itemList, data);
        }
    };
    const searchChange = (e) => {
        const { value } = e.target;
        setSearchValue(value);
        debounceSearchChange(value);
    };
    useContactItemEffect(defaultSelectList, () => {
        setSelectList(defaultSelectList);
    }, useContactId);
    const debounceSearchChange = useCallback(debounce(value => {
        var _a;
        onInputChange && onInputChange(value);
        (_a = contactListRef === null || contactListRef === void 0 ? void 0 : contactListRef.current) === null || _a === void 0 ? void 0 : _a.handleInputChange(value);
    }, 700), []);
    useEffect(() => {
        var _a;
        if (defaultSearchVal) {
            setSearchValue(defaultSearchVal);
            (_a = contactListRef === null || contactListRef === void 0 ? void 0 : contactListRef.current) === null || _a === void 0 ? void 0 : _a.handleInputChange(defaultSearchVal);
        }
    }, [defaultSearchVal]);
    const treeType = useMemo(() => {
        const typeSet = new Set(type);
        if (isCorpMail) {
            typeSet.delete('recent');
            typeSet.delete('enterprise');
        }
        if (!nimApi.getIMAuthConfig()) {
            typeSet.delete('team');
        }
        return [...typeSet];
    }, [isCorpMail, type]);
    return (React.createElement("div", { className: styles.selectContainer },
        showSearch ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.contactSearchWrap },
                React.createElement(LxInput, { "data-test-id": "contact_selectList_search_input", className: styles.contactSearch, ref: inputRef, value: searchValue, autoFocus: searchAutoFocus, onKeyDown: e => {
                        var _a;
                        (_a = contactListRef === null || contactListRef === void 0 ? void 0 : contactListRef.current) === null || _a === void 0 ? void 0 : _a.handleInputKeyDown(e);
                    }, onPressEnter: e => {
                        var _a;
                        (_a = contactListRef === null || contactListRef === void 0 ? void 0 : contactListRef.current) === null || _a === void 0 ? void 0 : _a.handleInputEnter(e);
                    }, onChange: e => searchChange(e), placeholder: getIn18Text('QINGSHURUSOUSUO'), prefix: React.createElement(SearchIcon, { className: "dark-invert" }), allowClear: true })),
            React.createElement("div", { className: styles.contactListTab, style: { height: containerHeight || undefined }, hidden: showSearch && searchValue === '' },
                React.createElement(SearchList, Object.assign({ accountRootKey: accountRootKey, useEdm: showAndUseEdm, isCustomerFirst: showAndUseEdm && isCustomerFirst, excludeSelf: excludeSelf, isIM: isIM, type: searchType, useContactId: useContactId, useOrgUnit: useOrgUnit, showCheckbox: showCheckbox, showAddTeamBtn: showAddTeamBtn, showAddPersonalBtn: showAddPersonalBtn, multiple: multiple, ref: contactListRef, disableCheckList: disableCheckList, defaultSelectList: selectList, onSelect: handleSelect, noRelateEnterprise: noRelateEnterprise, flattenPersonalEmails: flattenPersonalEmails, deduplicationByEmail: deduplicationByEmail }, searchListProps))))) : null,
        React.createElement("div", { className: styles.contactTreeTab, style: { height: containerHeight || undefined }, hidden: showSearch && searchValue !== '' },
            React.createElement(ContactTree, Object.assign({ accountRootKey: accountRootKey, useEdm: showAndUseEdm, useMultiAccount: useMultiAccount, excludeSelf: excludeSelf, isIM: isIM, type: treeType, useContactId: useContactId, useOrgUnit: useOrgUnit, multiple: multiple, order: order, defaultExpandedKeys: defaultExpandedKeys, showAddOrgBtn: showAddOrgBtn, showAddTeamBtn: showAddTeamBtn, showAddPersonalBtn: showAddPersonalBtn, showSeparator: showSeparator, showMailListEye: showMailListEye, showNoDataPlaceholder: showNoDataPlaceholder, showCheckbox: showCheckbox, disableCheckList: disableCheckList, defaultSelectList: selectList, onContactSelect: handleSelect, onExpand: onExpand, noRelateEnterprise: noRelateEnterprise, showOrgMemberNum: showOrgMemberNum, excludeOrgTypes: excludeOrgTypes }, treeProps)))));
};
export default SelectList;
